import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import {
  Box,
  Button,
  Card,
  Chip,
  IconButton,
  Modal,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import PropTypes from "prop-types";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import NodataImg from "../../assets/images/noData.png";
import { shortVideoApi } from "../../store/shortVideo/shortVideoList";
import { shortVideoDeleteApi } from "../../store/shortVideo/deleteShortVideo";
import { teachingVideoDeleteApi } from "../../store/teachingVideo/deleteTeachingVideo";
import { teachingVideoApi } from "../../store/teachingVideo/teachingVideoList";

export default function DeleteTeachingVideos({ open, setOpen, id }) {
  const shortVideoDelete = useSelector((state) => state?.teachingVideoDelete);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const handleClose = () => setOpen(false);

  const deleteCourseConfirm = async () => {
    await dispatch(
      teachingVideoDeleteApi(id)
    );
    setOpen(false);
    if (!shortVideoDelete?.loading) {
      dispatch(
        teachingVideoApi()
      );
      navigate("/teaching-videos");
    }

  };

  return (
    <>
      <Modal open={open} onClose={handleClose}>
        <Card className="modal" sx={{ width: "30%" }}>
          <Stack alignItems="flex-end">
            <IconButton onClick={handleClose}>
              <HighlightOffIcon />
            </IconButton>
          </Stack>
          <Stack alignItems="center" my={2}>
            <Typography variant="h5" fontWeight={600}>
              Are you sure you want to delete this  video ?
            </Typography>
            <Typography variant="h5" fontWeight={600}>
              Please click confirm
            </Typography>
          </Stack>


          <Stack sx={{ mt: 2 }} justifyContent="center" direction="row">
            <Button variant="outlined" onClick={() => setOpen(false)} sx={{ mr: 2 }}>
              Back
            </Button>
            <Stack direction="row" spacing={1}>
              {/* <Button variant='outlined' onClick={notRequiredOrderHandler}>Not Required</Button> */}
              <Button variant="contained" onClick={deleteCourseConfirm}>
                Confirm
              </Button>
            </Stack>
          </Stack>
        </Card>
      </Modal>
    </>
  );
}

DeleteTeachingVideos.propTypes = {
  open: PropTypes.any,
  setOpen: PropTypes.any,
  id: PropTypes.any,
};

